module.exports = __webpack_public_path__ + "images/feature/20170214_2-401b3da3116592cf9c78ee8e43c7374b.jpg";